import BaseObject, { BaseObjectParams } from '../baseObject';

export interface SoundParams extends BaseObjectParams {
  src: string;
  volume: number;
  ignoreCamera: boolean;
  minTimeBeforeLoop?: number;
}

export default class Sound extends BaseObject implements SoundParams
{
  static masterVolume = 1;
  static maxVolume = 1;
  static minVolume = 0;
  static cameraModifier = 1;

  src!: string;
  volume = 1;
  ignoreCamera = false;
  minTimeBeforeLoop: number | undefined = 0;

  audio!: HTMLAudioElement;

  constructor(params: SoundParams)
  {
    super();
    this.applyParams(params);
    this.setAudio();
  }

  getAudio(): HTMLAudioElement
  {
    return this.audio;
  }

  setAudio(): void
  {
    this.audio = new Audio();
    this.audio.src = this.src;
  }

  play(): Sound
  {
    this.setVolume(this.volume);
    this.audio.play();

    /* currentTime = 0 allow the Audio to play before the last sound finishes */
    if (this.audio.currentTime && this.minTimeBeforeLoop !== undefined)
      this.audio.currentTime = this.minTimeBeforeLoop;

    return this;
  }

  pause(): Sound
  {
    this.audio.pause();
    return this;
  }

  getRealVolume(volume: number): number
  {
    const cameraModifier = (this.ignoreCamera)
      ? 1
      : Sound.cameraModifier
    ;
    return Math.min(
      Math.max(
        Sound.masterVolume * volume * cameraModifier,
        Sound.minVolume
      ),
      Sound.maxVolume
    );
  }

  setVolume(volume: number): Sound
  {
    this.audio.volume = this.getRealVolume(volume);
    return this;
  }
}
